import React, { useState } from "react";
import "./waitlist.css";
import Seo from "../../seo/Seo";

const Waitlist = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    university: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Use formData values correctly
    const encodedData = new URLSearchParams();
    encodedData.append("name", formData.name);
    encodedData.append("email", formData.email);
    encodedData.append("university", formData.university);

    try {
      const response = await fetch(
        "https://script.google.com/macros/s/AKfycbwgouJ3NmP8DwvmgRYsfqO8PuMVx7jslJSGh2-5jbqiJqYY_6vUy4pezoL7AcAtK1C5yg/exec",
        {
          method: "POST",
          body: encodedData,
        }
      );

      const text = await response.text();
      if (text.includes("Success")) {
        alert("Thanks for joining the waitlist!");
        setFormData({ name: "", email: "", university: "" });
      } else {
        alert("There was an issue submitting your form. Please try again.");
      }
    } catch (error) {
      alert("There was an issue submitting your form. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="waitlist-page">
      <Seo path="/waitlist" />
      <div className="waitlist-card">
        <h1 className="waitlist-title">Join the Waitlist!</h1>
        <p className="waitlist-subtitle">
          Be among the first to access RAIN’s <span className="highlight-text">new Gmail integration</span>
        </p>

        <form onSubmit={handleSubmit} className="waitlist-form">
          <label className="waitlist-label">Name</label>
          <input
            type="text"
            name="name"
            placeholder="Enter your name"
            required
            className="waitlist-input"
            value={formData.name}
            onChange={handleChange}
          />

          <label className="waitlist-label">Email</label>
          <input
            type="email"
            name="email"
            placeholder="Enter your email"
            required
            className="waitlist-input"
            value={formData.email}
            onChange={handleChange}
          />

          <label className="waitlist-label">University</label>
          <input
            type="text"
            name="university"
            placeholder="Enter your university"
            required
            className="waitlist-input"
            value={formData.university}
            onChange={handleChange}
          />

          <button
            type="submit"
            className="waitlist-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "Join Waitlist"}
          </button>
        </form>

        <p className="waitlist-footer">
          We’ll only use this to contact you about early access.
        </p>
      </div>
    </div>
  );
};

export default Waitlist;
